import { ActionReducerMap, MetaReducer } from "@ngrx/store";
import environment from "../../environments/static";
import {
    ErrorDetailsState,
    errorDetailsReducer,
} from "./error-details/error-details.reducers";
import {
    errorSummaryReducer,
    ErrorSummaryState,
} from "./error-summary/error-summary.reducers";
import {
    batchCorrectionReducer,
    BatchCorrectionState,
} from "./batch-correction/batch-correction.reducers";
import {
    errorUpdateReducer,
    ErrorUpdateState,
} from "./error-update/error-update.reducers";
import {
    dashboardReducer,
    DashboardState,
} from "./dashboard/dashboard.reducers";
import {
    MITReducer,
    MITState,
} from "./missing-in-tracy/missing-in-tracy.reducers";
import {
    autoArchiveReducer,
    AutoArchiveState,
} from "./auto-archive/auto-archive.reducers";
import {
    reasoningReducer,
    ReasoningState,
} from "./reasoning/reasoning.reducers";
import {
    emailNotificationSettingsReducer,
    EmailNotificationSettingsState,
} from "./email-notification-settings/email-notification-settings.reducers";

export interface AppState {
    errorDetails: ErrorDetailsState;
    errorSummary: ErrorSummaryState;
    batchCorrection: BatchCorrectionState;
    errorUpdate: ErrorUpdateState;
    dashboard: DashboardState;
    MIT: MITState;
    autoArchive: AutoArchiveState;
    reasoning: ReasoningState;
    emailNotificationSettings: EmailNotificationSettingsState;
}

export const reducers: ActionReducerMap<AppState> = {
    errorDetails: errorDetailsReducer,
    errorSummary: errorSummaryReducer,
    batchCorrection: batchCorrectionReducer,
    errorUpdate: errorUpdateReducer,
    dashboard: dashboardReducer,
    MIT: MITReducer,
    autoArchive: autoArchiveReducer,
    reasoning: reasoningReducer,
    emailNotificationSettings: emailNotificationSettingsReducer,
};

export const metaReducers: MetaReducer<AppState>[] = environment.compiled
    ? []
    : [];
